export default __webpack_public_path__ + "22db1a5311fef5e95d31a0db79670a7e.woff2";